(function () {
  'use strict';
  function closest (el, predicate) {
    do if (predicate(el)) return el;
    while (el = el && el.parentNode);
  }

  var throttle = function(obj, type, newName) {
    var running = false;
    var func = function() {
      if (running) { return; }
      running = true;
       requestAnimationFrame(function() {
        obj.dispatchEvent(new CustomEvent(newName));
        running = false;
      });
    };
    obj.addEventListener(type, func);
  };

  function initSidebar() {
    if(!document.querySelector(".ric-sidebar--burger-slide")) {
      return;
    }
    var body = document.body;
    var burger = document.querySelector(".ric-sidebar__burger");

    if(!burger) {
      return;
    }
    var sidebar = document.querySelector(".ric-sidebar");
    burger.addEventListener('click', function(e) {
      e.preventDefault();
      if(!body.classList.contains('ric-sidebar--opened')) {
        body.classList.add('ric-sidebar--opened');
      } else {
        body.classList.remove('ric-sidebar--opened');
      }
    });
    body.addEventListener('click', function(e) {
      var inSidebar = closest(e.target, function(el) {
        if(el.matches && el.matches('.ric-sidebar, .ric-sidebar__burger')) {
          return el;
        }
      });
      if(!inSidebar) {
        body.classList.remove('ric-sidebar--opened');
      }
    });
    // handle event
    var header = document.querySelector('.ric-header__container');
    var top = header.getBoundingClientRect().bottom;
    sidebar.style['top'] = top+'px';
    throttle(window, 'resize', 'throttleResize');
    window.addEventListener("throttleResize", function() {
      var top = Math.max(0, header.getBoundingClientRect().bottom);
      sidebar.style['top'] = top+'px';
    });
    throttle(window, 'scroll', 'throttleResize');
  };
  initSidebar();

}());
